// Shared formatting utilities — used by HomeView, PortfolioView, AssetDetail

/**
 * Strips exchange suffixes and special chars so raw Yahoo Finance tickers
 * become a clean display symbol (e.g. "BTC-USD" → "BTC", "^GDAXI" → "GDAXI").
 */
export function cleanTicker(ticker) {
  return ticker.replace('-USD', '').replace('=X', '').replace('^', '').split('.')[0];
}

/**
 * Returns the ticker variant expected by the Parqet logo CDN.
 * Tickers with a dot suffix (e.g. "SAP.DE") are kept as-is; others are cleaned.
 */
export function logoTicker(ticker) {
  if (ticker.includes('.')) return ticker;
  return ticker.replace('-USD', '').replace('=X', '').replace('^', '');
}

/**
 * Formats a price value as a Euro string.
 * @param {number|null|undefined} v
 */
export function fmtPrice(v) {
  if (v == null || isNaN(v)) return '—';
  return `€${Number(v).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/**
 * Formats a percentage value with sign prefix.
 * @param {number|null|undefined} v
 * @param {number} [d=2] decimal places
 */
export function fmt(v, d = 2) {
  if (v == null || isNaN(v)) return '—';
  return `${v >= 0 ? '+' : ''}${Number(v).toFixed(d)}%`;
}

/**
 * Returns a human-readable exchange label for a given ticker symbol.
 */
export function getExchange(ticker) {
  if (ticker.endsWith('.DE')) return 'XETRA';
  if (ticker.endsWith('.PA')) return 'EURONEXT';
  if (ticker.endsWith('.SW')) return 'SIX';
  if (ticker.endsWith('.AS')) return 'EURONEXT';
  if (ticker.endsWith('-USD')) return 'CRYPTO';
  if (ticker.startsWith('^')) return 'INDEX';
  return 'NASDAQ';
}
